import React, { useState, useEffect } from 'react';
import './AdminVideos.css';

const AdminVideos = ({ onVolver }) => {
  const [videos, setVideos] = useState([]);
  const [title, setTitle] = useState('');
  const [description, setDescription] = useState('');
  const [videoType, setVideoType] = useState('local');
  const [file, setFile] = useState(null);
  const [youtubeId, setYoutubeId] = useState('');
  const [error, setError] = useState('');

  // --- NUEVOS ESTADOS PARA LA BARRA DE PROGRESO ---
  const [isUploading, setIsUploading] = useState(false);
  const [uploadProgress, setUploadProgress] = useState(0);

  useEffect(() => {
    const fetchVideos = async () => {
        try {
            const response = await fetch('https://api.interventorsisgafr.com/api/videos');
            const data = await response.json();
            setVideos(data);
        } catch (error) {
            console.error("Error fetching videos:", error);
        }
    };
    fetchVideos();
  }, []);

  // --- FUNCIÓN handleSubmit MODIFICADA PARA USAR XHR ---
  const handleSubmit = async (e) => {
    e.preventDefault();
    setError('');
    const token = localStorage.getItem('token');
    
    // Validaciones iniciales
    if (videoType === 'local' && !file) {
      return setError('Por favor, selecciona un archivo de video local.');
    }
    if (videoType === 'youtube' && !youtubeId) {
      return setError('Por favor, ingresa la ID del video de YouTube.');
    }

    const formData = new FormData();
    formData.append('data', JSON.stringify({ title, description, video_type: videoType, youtube_embed_id: youtubeId }));
    
    if (videoType === 'local') {
      formData.append('video', file);
    }

    // Se usa XMLHttpRequest (XHR) en lugar de fetch para poder monitorear el progreso
    const xhr = new XMLHttpRequest();

    // Event listener para el progreso de la subida
    xhr.upload.addEventListener('progress', (event) => {
      if (event.lengthComputable) {
        const percentComplete = Math.round((event.loaded / event.total) * 100);
        setUploadProgress(percentComplete);
      }
    });

    // Event listener para cuando la subida se completa (exitosa o no)
    xhr.addEventListener('load', () => {
      setIsUploading(false);
      setUploadProgress(0);
      
      try {
        const newVideo = JSON.parse(xhr.responseText);
        // Si el status no es 2xx (éxito)
        if (xhr.status < 200 || xhr.status >= 300) {
            throw new Error(newVideo.msg || `Error ${xhr.status}: ${xhr.statusText}`);
        }
        
        setVideos([newVideo, ...videos]);
        // Limpiar formulario manualmente ya que e.target.reset() no aplica
        setTitle('');
        setDescription('');
        setFile(null);
        setYoutubeId('');
        document.querySelector('input[type="file"]').value = ''; // Limpiar el input de archivo
        setVideoType('local');

      } catch (err) {
          setError(err.message || "Ocurrió un error al procesar la respuesta del servidor.");
      }
    });

    // Event listener para errores de red
    xhr.addEventListener('error', () => {
      setIsUploading(false);
      setUploadProgress(0);
      setError('Error de red. No se pudo completar la subida.');
    });

    // Inicia el proceso de subida
    xhr.open('POST', 'https://api.interventorsisgafr.com/api/videos');
    xhr.setRequestHeader('Authorization', `Bearer ${token}`);
    
    // Inicia los estados de carga
    setIsUploading(true);
    setUploadProgress(0);
    xhr.send(formData);
  };

  const handleDelete = async (id) => {
      if(!window.confirm('¿Seguro que quieres eliminar este video?')) return;
      const token = localStorage.getItem('token');
      try {
        await fetch(`https://api.interventorsisgafr.com/api/videos/${id}`, {
            method: 'DELETE',
            headers: { 'Authorization': `Bearer ${token}` }
        });
        setVideos(videos.filter(v => v.id !== id));
      } catch (error) {
        console.error("Error deleting video:", error);
      }
  };

  return (
    <div className="admin-videos-container">
      <button onClick={onVolver} className="volver-btn">&lt; Volver</button>
      <h2>Gestión de Videos</h2>
      
      <div className="admin-videos-content">
        <form onSubmit={handleSubmit} className="video-form">
          <h3>Añadir Nuevo Video</h3>
          {error && <p className="error-message">{error}</p>}
          <input type="text" placeholder="Título del video" value={title} onChange={e => setTitle(e.target.value)} required />
          <textarea placeholder="Descripción del video" value={description} onChange={e => setDescription(e.target.value)}></textarea>

          <div className="form-group">
            <label>Tipo de Video:</label>
            <select value={videoType} onChange={e => setVideoType(e.target.value)}>
              <option value="local">Subir Archivo Local</option>
              <option value="youtube">Insertar ID de YouTube</option>
            </select>
          </div>

          {videoType === 'local' && (
            <div className="form-group">
              <label>Archivo de Video:</label>
              <input type="file" accept="video/*" onChange={e => setFile(e.target.files[0])} />
            </div>
          )}

          {videoType === 'youtube' && (
            <div className="form-group">
              <label>ID de Video de YouTube:</label>
              <input type="text" placeholder="Ej: dQw4w9WgXcQ" value={youtubeId} onChange={e => setYoutubeId(e.target.value)} />
            </div>
          )}

          {/* --- NUEVA SECCIÓN DE BARRA DE PROGRESO --- */}
          {isUploading && (
            <div className="progress-bar-container">
              <div 
                className="progress-bar"
                style={{ width: `${uploadProgress}%` }}
              >
                {uploadProgress}%
              </div>
            </div>
          )}

          <button type="submit" disabled={isUploading}>
            {isUploading ? 'Cargando...' : 'Guardar Video'}
          </button>
        </form>

        <div className="videos-list">
          <h3>Videos Actuales</h3>
          {videos.map(video => (
            <div key={video.id} className="video-item">
              <span>{video.title} ({video.video_type === 'youtube' ? 'YouTube' : 'Local'})</span>
              <button onClick={() => handleDelete(video.id)} className="delete-btn">Eliminar</button>
            </div>
          ))}
        </div>
      </div>
    </div>
  );
};

export default AdminVideos;